import { Component, ViewEncapsulation, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
    selector: 'image-with-title',
    templateUrl: './image-with-title.component.html',
    styleUrls: ['./image-with-title.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ImageWithTitleComponent {
  @Input() data: ImageWithTitleVM;
}

export class ImageWithTitleVM {
  constructor(public Title: string, public ImageUrl: string) {}
}
